import type {
  ChartResolution,
  ChartSearchParams,
  HistoryWindow,
  PaneRead,
  PriceBasis,
} from '@/features/trading-chart/api/chartApi'

/**
 * Query keys for the full-page chart.
 *
 * Its own root, apart from `marketKeys`, so nothing that invalidates the market
 * screens reaches the chart's session-long config or its saved layouts.
 * A layout's content sits under the layout list's key, so the one
 * invalidation a save or delete makes clears both.
 */
export const chartKeys = {
  all: ['trading-chart'] as const,
  config: () => [...chartKeys.all, 'config'] as const,
  symbol: (symbol: string) => [...chartKeys.all, 'symbol', symbol] as const,
  search: (params: ChartSearchParams) => [...chartKeys.all, 'search', params] as const,
  history: (
    symbol: string,
    resolution: ChartResolution,
    window: HistoryWindow,
    basis: PriceBasis,
  ) => [...chartKeys.all, 'history', symbol, resolution, window, basis] as const,
  historyHead: (symbol: string, basis: PriceBasis) =>
    [...chartKeys.all, 'history-head', symbol, basis] as const,
  liveBar: (symbol: string, resolution: ChartResolution, basis: PriceBasis) =>
    [...chartKeys.all, 'live-bar', symbol, resolution, basis] as const,
  pane: (read: PaneRead, symbol: string) => [...chartKeys.all, 'pane', read, symbol] as const,
  time: () => [...chartKeys.all, 'time'] as const,
  layouts: () => [...chartKeys.all, 'layouts'] as const,
  layout: (layoutId: number) => [...chartKeys.layouts(), layoutId] as const,
  studyTemplates: () => [...chartKeys.all, 'study-templates'] as const,
  studyTemplate: (name: string) => [...chartKeys.studyTemplates(), name] as const,
}
